import * as apiHelper from '../../apiHelper';
import * as constants from "./constants";

import { pushError, popError, setUserLoggedOut } from '../global/actions';
const { addNewReview: addNewUserReview } = require('../user/actions');
const { addNewReview: addNewListingReview } = require('../listings/actions');


const controller = 'users';

const onPaymentMethodResponse = (json, dispatch) => {
  if (json.error) { dispatch(pushError(json.error)); }
  else if (json.message) { dispatch(pushError({ errType: 'paymentmethod', message: json.message })) }
  else { dispatch(setUserData(json.user)) }
}

export function getUserInfo(id) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiGet(controller, state.Global.token, id)
      .then(response => response.json())
      .then(json => dispatch(setUserData(json.user)));
  }
}

export function fetchPaymentBilling(type, cb) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiGet(controller, state.Global.token, state.Global.userId, ["billing", type])
      .then(response => response.json())
      .then(json => { if (typeof cb === "function") cb(json) });
  }
}

export function updatePaymentBilling(type, values) {
  return (dispatch, getState) => {
    let state = getState();
    popError('paymentmethod');
    return apiHelper.apiPost(controller, values, state.Global.token, state.Global.userId, ["billing", type])
      .then(response => response.json())
      .then(json => {
        onPaymentMethodResponse(json, dispatch);
      });
  }
}

export function updatePaymentMethod(values) {
  return (dispatch, getState) => {
    let state = getState();
    popError('paymentmethod');
    return apiHelper.apiPut(controller, values, state.Global.token, state.Global.userId, ["paymentmethods"])
      .then(response => response.json())
      .then(json => {
        onPaymentMethodResponse(json, dispatch);
      });
  }
}

export function getMessagingAccessToken() {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost('messages', { device: 'browser' }, state.Global.token, 'token')
      .then(response => response.json())
      .then(json => {
        if (json.error) { console.log("Failed to fetch Access Token: " + error) }
        else if (json.auth === false) {
          dispatch(setUserLoggedOut());
        } else {
          dispatch(setMessagingToken(json));
          if (state.Dashboard.messagingClient
            && state.Dashboard.messagingToken.token !== json.token) {
            state.Dashboard.messagingClient.updateToken(json.token);
          }
        }
      })
  }
}

export function getMessagingClient() {
  return (dispatch, getState) => {
    let state = getState();
    let user = state.Dashboard.user;
    let token = state.Dashboard.messagingToken.token;
    Twilio.Chat.Client.create(token).then((client) => {
      client.getUser(user._id).then(_user => {
        let friendlyName = `${user.firstName} ${user.lastName.substr(0, 1)}.`;
        if (_user.friendlyName !== friendlyName) {
          _user.updateFriendlyName(friendlyName);
        }
        if (_user.attributes.photo !== user.profile.photo) {
          _user.updateAttributes({ photo: user.profile.photo });
        }
      }).catch(e => {/*console.log(e)*/ });
      client.addListener('tokenAboutToExpire', () => { dispatch(getMessagingAccessToken()) });
      client.addListener('tokenExpired', () => { dispatch(getMessagingAccessToken()) })
      dispatch(setMessagingClient(client));
      dispatch(getNotificationCount());
    }).catch(e => {/*console.log(e)*/ })
  }
}

export function initiateMessaging(contactForm) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost('messages', contactForm, state.Global.token)
      .then(response => response.json())
      .then(json => {
        if (json.error) { dispatch(pushError(json.error.message)); }
        else { /* channel created successfully */ }
      });
  }
}

export function getNotificationCount() {
  return (dispatch, getState) => {
    let state = getState();
    let messagingClient = state.Dashboard.messagingClient;
    if (!messagingClient || !state.Global.userId) { return; }
    messagingClient.getSubscribedChannels().then(_channels => {
      let unconsumedMessageCountPromises = _channels.items.map(_c => _c.getUnconsumedMessagesCount());
      Promise.all(unconsumedMessageCountPromises).then(values => {
        let notificationCount = 0;
        values.map(v => {
          if (v > 0) {
            const notCount = notificationCount;
            ++notificationCount;
            return notCount;
          }
          return 0;
        });
        dispatch(setNotificationCount(notificationCount));
      })
    }).catch(e => {
      if (messagingClient.status !== 'connected') {
        dispatch(getMessagingAccessToken());
      }
    })
  }
}

export function addNewReview(values, cb) {
  return (dispatch, getState) => {
    let state = getState();
    let booking = state.Booking;
    //Check if rating is based off renter's list
    let ratedBooking = booking.bookings.filter(b => b._id === values.id)[0];
    if (ratedBooking) {
      dispatch(addNewListingReview(typeof ratedBooking.listingId == 'object' ? ratedBooking.listingId._id : ratedBooking.listingId, values, cb));
    } else {
      //Check if rating is based off owner's list
      ratedBooking = booking.listingBookings.filter(b => b._id === values.id)[0];
      if (ratedBooking) {
        dispatch(addNewUserReview(typeof ratedBooking.userId == 'object' ? ratedBooking.userId._id : ratedBooking.userId, values, cb));
      }
    }
  }
}

export function updateUser(userToUpdate) {
  return (dispatch, getState) => {
    let state = getState();
    let user = userToUpdate ? userToUpdate : state.User.profile;

    return apiHelper.apiPut('users', user, state.Global.token, user._id)
      .then(response => response.json())
      .then(json => {
        if (json.error) { dispatch(pushError({ errType: "userupdate", error: json.error })) }
        else if (userToUpdate._id) { dispatch(setUserData(json.user)) }
      })
  }
}

export function checkEmail(email, userId, cb) {
  return () => {
    return apiHelper.apiPost('users', { email: email, userId: userId }, null, 'checkEmail')
      .then(response => response.json())
      .then(json => {
        if (json.emailAvailable) {
          cb(true);
        } else {
          cb(false);
        }
      })
  }
}

export function setUserData(userData) {
  return {
    type: constants.SET_USER_DATA,
    data: userData
  }
}

function setPaymentMethods(paymentMethods) {
  return {
    type: constants.SET_PAYMENT_METHODS,
    data: paymentMethods
  }
}

function setStripeLoginUri(json) {
  return {
    type: constants.SET_STRIPE_URI,
    data: json
  }
}

function setMessagingToken(token) {
  return {
    type: constants.SET_MESSAGING_TOKEN,
    data: token
  }
}

function setMessagingClient(client) {
  return {
    type: constants.SET_MESSAGING_CLIENT,
    data: client
  }
}

function setNotificationCount(count) {
  return {
    type: constants.SET_NOTIFICATION_COUNT,
    data: count
  }
}
